// Bubbles drifting up from the bottom for the ocean theme.
export function Bubbles() {
  return (
    <div className="theme-decoration theme-decoration-bubbles" aria-hidden="true">
      <span className="bubble bubble-1">🫧</span>
      <span className="bubble bubble-2">🫧</span>
      <span className="bubble bubble-3">🫧</span>
      <span className="bubble bubble-4">🫧</span>
      <span className="bubble bubble-5">🫧</span>
    </div>
  );
}
